import React, { useState } from "react";
// import stemBanner from "../assets/images/stem_banner.png";
// import webBanner from "../assets/images/web_banner.png";
// import pcbBanner from "../assets/images/pcb_banner.png";
// import iotBanner from "../assets/images/IOT_banner.png";
import pythonBanner from "../assets/images/python_banner.png";
import logoIcon from "../assets/images/learning_logo.png";
// import droneBanner from "../assets/images/drone_banner.png";

const coursesData = [
  {
    category: "Software",
    courses: [
      {
  title: "Python Programming",
  platformLink: "https://learning.enteai.in",
  duration: "3 Months",
  level: "Software",
  desc: "A 12-week hands-on program covering Python fundamentals, Object-Oriented Programming (OOP), APIs, data analytics with Pandas, and applied capstone projects.",
  imageUrl: pythonBanner,
  keyAreas: [
    "Python Fundamentals & Data Structures",
    "Functions & Modular Programming",
    "Object-Oriented Programming (OOP)",
    "File Handling & CSV Processing",
    "APIs & JSON Basics",
    "Data Analytics with Pandas",
    "Hands-on Projects"
  ],
  timeline: [
    {
      title: "Month 1 – Python Foundations & Data Structures",
      lessons: [
        "Python introduction, setup, VS Code & first program",
        "Variables, data types, input/output & operators",
        "Conditions, nested if/else & flowchart thinking",
        "Loops (for & while), patterns & logical iterations",
        "Lists, tuples, dictionaries & sets with real examples",
        "Project",
        "📝 Weekly Assignments + Quizes"
      ]
    },
    {
      title: "Month 2 – Functions, Files & Object-Oriented Programming",
      lessons: [
        "Functions, parameters, return values & scope",
        "Modules, file handling (read/write) & CSV processing",
        "Classes & objects, constructors & attributes",
        "Inheritance, encapsulation & access control",
        "Polymorphism, class/static methods & OOP best practices",
        "Project",
        "📝 Weekly Assignments + Quizes"
      ]
    },
    {
      title: "Month 3 – Advanced Python, APIs & Data Analytics",
      lessons: [
        "List/dict comprehensions, lambda functions & error handling",
        "Clean coding practices & code readability techniques",
        "APIs, JSON basics & Python Requests library (GET/POST)",
        "Pandas — DataFrames, data cleaning, GroupBy & aggregation",
        "Exporting reports to CSV/Excel & analytics workflows",
        "Final Project: End-to-end data analytics capstone app",
        "📝 Weekly Assignments + Quizes"
      ]
    }
  ],
  deliverables: [
    "12 weeks of structured training (theory + lab)",
    "8+ mini-projects + 2 major projects",
    "Exposure to real-world problem solving",
    "Team-based learning & project documentation",
    "Certificate of Completion"
  ]
},
    ],
  },
];

function CoursesPage() {
  const [selectedCourse, setSelectedCourse] = useState(null);

  // Flatten all courses into a single array
  const allCourses = coursesData.flatMap(set => set.courses);

  // Helper to resolve image paths for local images
  function resolveImageUrl(url) {
  return url;
  }

  return (
    <div className="bg-gray-50 min-h-screen pt-24 px-4">
      {/* Learning Platform Banner */}
      <div className="max-w-6xl mx-auto mb-12 bg-gradient-to-r from-[#003049] to-[#457B9D] rounded-2xl p-8 md:p-12 shadow-xl flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex flex-col md:flex-row items-center gap-6 text-center md:text-left">
          <img src={logoIcon} alt="Ente AI Logo" className="w-24 h-24 md:w-28 md:h-28 object-contain drop-shadow-lg" />
          <div>
            <h2 className="text-2xl md:text-4xl font-bold text-white mb-4">
              Ente AI Learning Platform
            </h2>
            <p className="text-1xl md:text-2xl e mb-4 font-semibold text-[#D1D1D1]">
                  Build Skills That Matter
                </p>
            <p className="text-blue-100 text-lg max-w-xl">
              Access our comprehensive digital library, track your progress, and join interactive coding sessions on our dedicated learning portal.
            </p>
          </div>
        </div>
        <button 
          onClick={() => window.open("https://learning.enteai.in", "_blank")}
          className="bg-[#D1D1D1] text-[#003049] px-8 py-4 rounded-xl font-bold text-lg hover:bg-white transition-all shadow-lg hover:shadow-2xl whitespace-nowrap"
        >
          Go to Platform →
        </button>
      </div>
      
      <h1 className="text-3xl font-bold text-center mb-2">
        Our Training Courses
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {allCourses.map((course, idx) => (
          <div
            key={idx}
            className="bg-white rounded-xl shadow p-4 flex flex-col cursor-pointer hover:shadow-lg transition"
            onClick={() => setSelectedCourse(course)}
          >
            <img
              src={resolveImageUrl(course.imageUrl)}
              alt={course.title}
              className="rounded-lg mb-4 w-full h-40 object-cover bg-gray-100"
            />
            <div className="flex items-center gap-2 mb-2">
              <span className="px-2 py-0.5 bg-blue-50 text-blue-600 text-xs rounded font-semibold">
                {course.level}
              </span>
            </div>
            <h2 className="font-bold text-lg mb-2">{course.title}</h2>
            <p className="text-gray-600 mb-4 font-bold">{course.duration}</p>
            <p className="text-gray-600 mb-4">{course.desc}</p>
            
            {course.platformLink && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  window.open(course.platformLink, "_blank");
                }}
                className="mt-auto bg-[#003049] text-white px-4 py-2 rounded-lg font-semibold hover:bg-[#457B9D] transition w-full text-center shadow"
              >
                Launch Platform
              </button>
            )}
          </div>
        ))}
      </div>

      {/* Modal */}
      {selectedCourse && (
        <div className="fixed inset-0 z-60 flex items-center justify-center bg-black bg-opacity-60">
          <div className="bg-white rounded-xl shadow-lg max-w-lg w-full p-6 relative max-h-[80vh] flex flex-col">
            <button
              className="absolute top-3 right-3 text-gray-500 text-2xl font-bold"
              onClick={() => setSelectedCourse(null)}
              aria-label="Close"
            >
              ×
            </button>
            <div className="overflow-y-auto pr-2" style={{ maxHeight: "70vh" }}>
              <img
                src={resolveImageUrl(selectedCourse.imageUrl)}
                alt={selectedCourse.title}
                className="rounded-lg mb-4 w-full h-40 object-cover bg-gray-100"
              />
              <h2 className="font-bold text-2xl mb-2">{selectedCourse.title}</h2>
              <p className="text-gray-600 mb-4 font-bold">{selectedCourse.duration}</p>
              <p className="text-gray-600 mb-4">{selectedCourse.desc}</p>
              
              {selectedCourse.platformLink && (
                <button
                  onClick={() => window.open(selectedCourse.platformLink, "_blank")}
                  className="mb-4 bg-[#003049] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#457B9D] transition w-full md:w-auto text-center shadow"
                >
                  Launch Platform
                </button>
              )}
              <div className="mb-4">
                <h3 className="font-semibold mb-2">Key Areas Covered:</h3>
                <ul className="list-disc list-inside text-gray-700">
                  {selectedCourse.keyAreas.map((area, i) => (
                    <li key={i}>{area}</li>
                  ))}
                </ul>
              </div>
              <div>
                <h3 className="font-semibold mb-2">Timeline:</h3>
                {selectedCourse.timeline.map((section, i) => (
                  <div key={i} className="mb-3">
                    <div className="font-bold">{section.title}</div>
                    <ul className="list-none ml-2">
                      {(section.lessons || []).map((lesson, j) => (
                        <li key={j} className="flex items-center gap-2 py-1">
                          <span className="inline-block w-4 h-4 text-gray-400">
                            📄
                          </span>
                          <span>{lesson}</span>
                        </li>
                      ))}
                      {/* For software course weeks */}
                      {(section.weeks || []).map((week, k) => (
                        <li key={k}>
                          <div className="font-bold">{week.title}</div>
                          <ul className="list-disc ml-4">
                            {week.lessons.map((lesson, l) => (
                              <li key={l}>{lesson}</li>
                            ))}
                          </ul>
                          {week.project && (
                            <div className="text-blue-600 font-semibold mt-1">
                              {week.project}
                            </div>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CoursesPage;
